import { Injectable, inject } from "@angular/core";
import {IssueContentType, IssueType} from "@server-models";
import {TeamIssueMessageApiService} from "@team/pages/issues/services/team-issue-message-api.service";
import {TeamIssueMissionApiService} from "@team/pages/issues/services/team-issue-mission-api.service";
import {TeamIssueTicketApiService} from "@team/pages/issues/services/team-issue-ticket-api.service";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";
import {TeamIssueControlMessageApiService} from "@team/pages/issues/services/team-issue-control-message-api.service";
import {TeamIssueDirectMessageApiService} from "@team/pages/issues/services/team-issue-direct-message-api.service";

@Injectable({
  providedIn: 'root',
})
export class TeamIssueService {
  private _teamIssuesDirectMessageApiService = inject(TeamIssueDirectMessageApiService);
  private _teamIssuesMessageApiService = inject(TeamIssueMessageApiService);
  private _teamIssuesMissionApiService = inject(TeamIssueMissionApiService);
  private _teamIssuesTicketApiService = inject(TeamIssueTicketApiService);
  private _teamIssuesControlMessageApiService = inject(TeamIssueControlMessageApiService);


  getApiServiceByIssueType(issueType: IssueType): IIssueService {
    switch (issueType) {
      case IssueType.Message:
        return this._teamIssuesMessageApiService;
      case IssueType.DirectMessage:
        return this._teamIssuesDirectMessageApiService;
      case IssueType.Mission:
        return this._teamIssuesMissionApiService;
      case IssueType.Ticket:
        return this._teamIssuesTicketApiService;
      case IssueType.ControlMessage:
        return this._teamIssuesControlMessageApiService;
      default:
        throw new Error(`Api service, Unsupported issue type: ${ issueType }`);
    }
  }

  getApiServiceByIssueContentType(issueContentType: IssueContentType): IIssueService {
    switch (issueContentType) {
      case IssueContentType.Message:
        return this._teamIssuesMessageApiService;
      case IssueContentType.DirectMessage:
        return this._teamIssuesDirectMessageApiService;
      case IssueContentType.Mission:
        return this._teamIssuesMissionApiService;
      case IssueContentType.Ticket:
        return this._teamIssuesTicketApiService;
      default:
        throw new Error(`Api service, Unsupported issue content type: ${ issueContentType }`);
    }
  }


}
